import { useState, useContext, useRef, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Utils from '@utils/utils';

export default function PcLayout () {

    useEffect(() => {
        if(Utils.isMobileDevice()) {
            const html = document.querySelector('html')
            html.style.setProperty('--min-font-size', '0px');
            html.style.setProperty('--max-font-size', '100px');
            html.style.setProperty('--base-width', '768');
        } else {
            const html = document.querySelector('html')
            html.style.setProperty('--min-font-size', '50px');
            html.style.setProperty('--max-font-size', '999px');
            html.style.setProperty('--base-width', '1920');
        }
    }, [])

    return (
        <div
            style={{
                width: '100vw',
                height: '100vh',
                overflow: "hidden",
            }}
        >
            <Outlet />
        </div>
    )
}